export { default } from './PortadaButlletins';
